import { z } from "zod";
import {
  ChassisSchema,
  LocalizedTextSchema,
  ManufacturerSchema,
  RoleSchema,
  SUPPORT_CHASSIS,
  TIER_ABILITY_COUNT,
  TierSchema,
  idPattern,
} from "./common.js";

export const AbilityRefSchema = z.object({
  archetype: idPattern("abl"),
  name: LocalizedTextSchema,
  params: z.record(z.string(), z.number()),
});
export type AbilityRef = z.infer<typeof AbilityRefSchema>;

export const UnitDefSchema = z
  .object({
    id: idPattern("unit"),
    name: LocalizedTextSchema,
    mfr: ManufacturerSchema,
    chassis: ChassisSchema,
    role: RoleSchema,
    tier: TierSchema,
    standard: AbilityRefSchema,
    uniques: z.array(AbilityRefSchema).max(4),
    /** Commanders only: share of the front's combined health their own frame carries (40-combat.md R38). */
    commandFrame: z.number().min(100).max(150).optional(),
    bio: LocalizedTextSchema,
  })
  .superRefine((u, ctx) => {
    const expected = TIER_ABILITY_COUNT[u.tier] - 1;
    if (u.role === "commander" && u.commandFrame === undefined)
      ctx.addIssue({ code: "custom", message: "commanders need a command frame", path: ["commandFrame"] });
    if (u.role !== "commander" && u.commandFrame !== undefined)
      ctx.addIssue({ code: "custom", message: "only commanders carry a command frame", path: ["commandFrame"] });
    if (u.uniques.length !== expected)
      ctx.addIssue({ code: "custom", message: `${u.tier} tier needs ${expected} unique abilities`, path: ["uniques"] });
    if (u.role === "support" && !SUPPORT_CHASSIS.includes(u.chassis))
      ctx.addIssue({ code: "custom", message: "supports must be androids or drone carriers", path: ["chassis"] });
    if (u.role !== "support" && u.chassis === "drone_carrier")
      ctx.addIssue({ code: "custom", message: "drone carriers are support only", path: ["chassis"] });
  });
export type UnitDef = z.infer<typeof UnitDefSchema>;
